<template>
  <div class="flex-grid flex-grid--halfs row">
    <div class="col data-block no-border">
      <div class="block-title ttu">
        <p>
          {{ $t('Current') }}
        </p>
      </div>
      <Icon :weatherZone="weatherZone" />
      <p class="skies-text ttu o-55 show-tablet">
        {{ weatherZone.Skies }}
      </p>

      <p class="high-low-temps">
        <span>H:</span> <strong>{{ tempHigh }}&ordm;</strong> /
        <span>L:</span> <strong>{{ tempLow }}&ordm;</strong>
      </p>

      <p class="wind-speed-text" v-if="windSpeed">
        Wind: <strong>{{ windSpeed }} {{ windDirection }}</strong>
      </p>
    </div>

    <div class="col data-block temperature-block">
      <p class="temperature" id="imperial-unit">
        <span id="metric-unit">{{ temperature }}</span>
      </p>
      <div class="temp-measurement" :class="{'show-metric': temperatureInMetric}">
        <a href="#metric" @click.prevent="toggleUnits('metric')" class="scale c noscroll">
          <span tabindex="-1">&ordm;C</span>
        </a>
        <a href="#imperial" @click.prevent="toggleUnits('imperial')" class="scale f noscroll">
          <span tabindex="-1">&ordm;F</span>
        </a>
      </div>
      <div class="skies-text ttu o-55 hide-tablet">{{ weatherZone.Skies }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Icon from './Icon.vue';

export default {
  name: 'WeatherCurrent',
  props: ['weatherZone'],
  components: { Icon },
  computed: {
    windSpeed() {
      if (this.weatherZone.WindMph === '--') { return; }

      if (this.weatherZone.WindMph) {
        return this.windspeedUnit === 'metric'
          ? `${this.weatherZone.WindKph}kph`
          : `${this.weatherZone.WindMph}mph`;
      }
    },
    windDirection() {
      return this.weatherZone.WindDirection;
    },
    temperature() {
      if (this.weatherZone.TempF) {
        return this.temperatureUnit === 'metric'
          ? this.weatherZone.TempC.split('.')[0]
          : this.weatherZone.TempF.split('.')[0];
      }
    },
    tempHigh() {
      if (this.weatherZone.TempHighF) {
        return this.temperatureUnit === 'metric'
          ? this.weatherZone.TempHighC.split('.')[0]
          : this.weatherZone.TempHighF.split('.')[0];
      }
    },
    tempLow() {
      if (this.weatherZone.TempLowF) {
        return this.temperatureUnit === 'metric'
          ? this.weatherZone.TempLowC.split('.')[0]
          : this.weatherZone.TempLowF.split('.')[0];
      }
    },
    temperatureInMetric() {
      return this.temperatureUnit == 'metric';
    },

    ...mapState([
      'windspeedUnit',
      'temperatureUnit',
    ]),
  },

  methods: {
    toggleUnits(unit) {
      this.$store.dispatch(
        'setWeatherUnits',
        {
          temperature_Unit: unit,
          windspeed_Unit: unit,
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  .flex-grid--halfs {
    align-items: flex-start;
    > .col {
      flex-basis: 48.5%;
      max-width: 48.5%;
      @media (max-width: $tablet) {
        flex-basis: 48.5%;
        max-width: 48.5%;
      }
    }
  }


.skies-text {
  color: $dark-gray;
  font-size: 13px;
  line-height: 1.2;
  margin-top: -5px;
  white-space: nowrap;
  @media (min-width: $tablet) {
    margin-top: 0px;
  }
}

.high-low-temps, .wind-speed-text {
  color: $dark-gray;
  font-family: $proxima-regular;
  font-size: 12px;
  line-height: 1.2;
  margin-top: 0px;
  @media (min-width: $tablet) {
    font-size: 14px;
  }
  span {
    font-family: $proxima-bold;
  }
}

.high-low-temps {
  display: none; // overriden in overrides for DV only for now
  font-size: 14px;
  margin: 5px 0;
}


.temperature-block {
  max-width: 120px;
  position: relative;
  left: 10px;
  top: 42px;
  @media (min-width: $tablet) {
    top: 50px;
  }
  .temperature {
    color: $dark-gray;
    font-family: $proxima-regular;
    font-size: 38px;
    line-height: 1.2;
    margin: -10px 0 0 0;
    @media (min-width: $tablet) {
      font-size: 62px;
    }
  }
  .skies-text {
  }

  .temp-measurement {
    right: 10%;
    position: absolute;
    top: -10px;
    @media (min-width: $mobile) {
      right: 22%;
    }
    @media (min-width: $tablet) {
      right: 10%;
      top: 0;
    }

    .scale {
      clear: right;
      color: $dark-gray;
      display: none;
      float: right;
      font-size: 12px;
      letter-spacing: 1.4px;

      &:active, &.f {
        display: block;
      }
    }
    &.show-metric {
      .scale {
        &.c {
          display: block;
        }
        &.f {
          display: none;
        }
      }
    }
  }
}
</style>

<i18n locale="fr-ca">
{
  "Current": "Aujourd'Hui"
}
</i18n>
